import { Modal, QRCode } from 'antd';

import React, { useCallback, useRef, useEffect, useState } from 'react';
import { ACCOUNT } from '../../redux/actions/accountActions';
import { useDispatch, useSelector } from 'react-redux';
import config from '../../system/config';

const MobileAppPromotionPopup = () => {
    const dispatch = useDispatch();

    const { isOpened } = useSelector((state) => state.mobileAppPromotionPopup);
    const handleClosePopup = useCallback(() => {
        dispatch({
            type: ACCOUNT.CLOSE_MOBILE_APP_PROMOTION_POPUP,
        });
    }, [dispatch]);

    return (
        <Modal
            open={isOpened}
            styles={{ body: { padding: 0 } }}
            width={470}
            footer={null}
            closable={false}
            onCancel={handleClosePopup}
            className="register-modal"
        >
            <div className="general-popup app-promotion-popup" id="verification">
                <h2 className="modal-title">Download our mobile application</h2>
                <div className="sub-title">Continue chatting in the mobile application. It’s fun and easy!</div>
                <div className="btn-wrap confirm-ban-buttons">
                    <QRCode value={`${config.tapPageUrl + 'interaction/app-stores'}`} />
                </div>
            </div>
        </Modal>
    );
};

export default MobileAppPromotionPopup;
